// Editable content for Good Looks Unisex Salon
// Replace copy, prices, hours, phone, and images freely — structure will hold.

export const BUSINESS = {
  name: "Good Looks Unisex Salon",
  tagline: "The neighbourhood atelier for hair, skin & bridal craft.",
  address: {
    line1: "Sunni Gali, Sadar",
    line2: "Mansa, Punjab 151505",
    country: "India",
  },
  phone: "+91 76960 87114",
  phoneHref: "tel:+917696087114",
  whatsapp: "+91 76960 87114",
  whatsappHref: "https://wa.me/917696087114",
  email: "hello@goodlooks.salon",
  hours: [
    { day: "Monday", time: "10:00 – 20:00" },
    { day: "Tuesday", time: "10:00 – 20:00" },
    { day: "Wednesday", time: "10:00 – 20:00" },
    { day: "Thursday", time: "10:00 – 20:00" },
    { day: "Friday", time: "10:00 – 20:00" },
    { day: "Saturday", time: "09:30 – 21:00" },
    { day: "Sunday", time: "10:00 – 19:00" },
  ],
  // Google Maps embed pointing to the Good Looks Business Profile
  mapEmbed:
    "https://www.google.com/maps?q=Good+Looks+Unisex+Salon,+Sunni+Gali,+Sadar,+Mansa,+Punjab&z=16&output=embed",
  mapLink: "https://share.google/qnxo0GJn0hk9FSaSD",
  social: {
    instagram: "https://www.instagram.com/goodlookssalonmansa/",
    facebook: "#",
  },
};

// In-salon photography + brand assets.
export const IMAGES = {
  logo: "https://customer-assets-m6fa6gv7.emergentagent.net/job_salon-sunni-gali/artifacts/x41q60v9_IMG_2783.JPG",
  interior:
    "https://images.pexels.com/photos/7750114/pexels-photo-7750114.jpeg?auto=compress&w=1800",
  modelBlonde:
    "https://customer-assets-m6fa6gv7.emergentagent.net/job_salon-sunni-gali/artifacts/zqcv8tf0_2025-08-09.jpg",
  modelPortrait:
    "https://customer-assets-m6fa6gv7.emergentagent.net/job_salon-sunni-gali/artifacts/b7pxrs1v_2023-10-20.jpg",
  salonExterior:
    "https://customer-assets-m6fa6gv7.emergentagent.net/job_salon-sunni-gali/artifacts/29vmpvgf_ChatGPT%20Image%20Jul%2026%2C%202026%2C%2008_01_13%20AM.png",
  salonReception:
    "https://customer-assets-m6fa6gv7.emergentagent.net/job_salon-sunni-gali/artifacts/x3zkspsb_ChatGPT%20Image%20Jul%2026%2C%202026%2C%2008_19_49%20AM.png",
  hero: "https://images.pexels.com/photos/7750114/pexels-photo-7750114.jpeg?auto=compress&w=1800",
  heroSecondary:
    "https://images.pexels.com/photos/705255/pexels-photo-705255.jpeg?auto=compress&w=1400",
  aboutInterior:
    "https://images.pexels.com/photos/7195808/pexels-photo-7195808.jpeg?auto=compress&w=1600",
  aboutPortrait:
    "https://customer-assets-m6fa6gv7.emergentagent.net/job_salon-sunni-gali/artifacts/b7pxrs1v_2023-10-20.jpg",
  bridal:
    "https://images.pexels.com/photos/34557187/pexels-photo-34557187.jpeg?auto=compress&w=1600",
  bridalWide:
    "https://images.pexels.com/photos/32170148/pexels-photo-32170148.jpeg?auto=compress&w=1800",
  contact:
    "https://images.pexels.com/photos/7195808/pexels-photo-7195808.jpeg?auto=compress&w=1600",
};

// North Indian bridal imagery — replace with real bride portfolio when available.
export const BRIDE_GALLERY = [
  "https://images.pexels.com/photos/17154861/pexels-photo-17154861.jpeg?auto=compress&w=1400",
  "https://images.pexels.com/photos/17001511/pexels-photo-17001511.jpeg?auto=compress&w=1400",
  "https://images.pexels.com/photos/29396108/pexels-photo-29396108.jpeg?auto=compress&w=1400",
  "https://images.pexels.com/photos/28941551/pexels-photo-28941551.jpeg?auto=compress&w=1400",
  "https://images.pexels.com/photos/32170148/pexels-photo-32170148.jpeg?auto=compress&w=1400",
  "https://images.pexels.com/photos/17154866/pexels-photo-17154866.jpeg?auto=compress&w=1400",
  "https://images.pexels.com/photos/25811178/pexels-photo-25811178.jpeg?auto=compress&w=1400",
  "https://images.pexels.com/photos/32107219/pexels-photo-32107219.jpeg?auto=compress&w=1400",
];

export const GALLERY = [
  // Salon interiors & work
  "https://images.pexels.com/photos/3993449/pexels-photo-3993449.jpeg?auto=compress&w=1200",
  "https://images.pexels.com/photos/3993456/pexels-photo-3993456.jpeg?auto=compress&w=1200",
  "https://images.pexels.com/photos/1813272/pexels-photo-1813272.jpeg?auto=compress&w=1200",
  "https://images.pexels.com/photos/3992874/pexels-photo-3992874.jpeg?auto=compress&w=1200",
  "https://images.pexels.com/photos/3065171/pexels-photo-3065171.jpeg?auto=compress&w=1200",
  "https://images.pexels.com/photos/3993323/pexels-photo-3993323.jpeg?auto=compress&w=1200",
  // North Indian brides
  "https://images.pexels.com/photos/17154861/pexels-photo-17154861.jpeg?auto=compress&w=1200",
  "https://images.pexels.com/photos/17001511/pexels-photo-17001511.jpeg?auto=compress&w=1200",
  "https://images.pexels.com/photos/29396108/pexels-photo-29396108.jpeg?auto=compress&w=1200",
  "https://images.pexels.com/photos/28941551/pexels-photo-28941551.jpeg?auto=compress&w=1200",
  "https://images.pexels.com/photos/32170148/pexels-photo-32170148.jpeg?auto=compress&w=1200",
  "https://images.pexels.com/photos/17154866/pexels-photo-17154866.jpeg?auto=compress&w=1200",
];

export const FEATURED_SERVICES = [
  {
    title: "Men's Haircut",
    startingFrom: "₹150",
    img: "https://images.unsplash.com/photo-1503951914875-452162b0f3f1?w=900&q=80",
    blurb: "Precision cuts tailored to face, hair type and lifestyle.",
  },
  {
    title: "Women's Haircut",
    startingFrom: "₹300",
    img: "https://customer-assets-m6fa6gv7.emergentagent.net/job_salon-sunni-gali/artifacts/b7pxrs1v_2023-10-20.jpg",
    blurb: "Studio-quality cuts, styling and finishing.",
  },
  {
    title: "Hair Colour & Highlights",
    startingFrom: "₹500",
    img: "https://customer-assets-m6fa6gv7.emergentagent.net/job_salon-sunni-gali/artifacts/zqcv8tf0_2025-08-09.jpg",
    blurb: "Editorial colour — balayage, highlights and root touch-ups.",
  },
  {
    title: "Keratin & Smoothening",
    startingFrom: "₹2,500",
    img: "https://images.unsplash.com/photo-1560066984-138dadb4c035?w=900&q=80",
    blurb: "Long-lasting frizz control with premium formulas.",
  },
  {
    title: "Facials & Clean-ups",
    startingFrom: "₹200",
    img: "https://images.unsplash.com/photo-1570172619644-dfd03ed5d881?w=900&q=80",
    blurb: "From express clean-ups to Korean glass rituals.",
  },
  {
    title: "Hydra Facial",
    startingFrom: "₹2,000",
    img: "https://images.unsplash.com/photo-1487412947147-5cebf100ffc2?w=900&q=80",
    blurb: "Deep-clean, hydrate and glow in a single sitting.",
  },
  {
    title: "Party & HD Makeup",
    startingFrom: "₹800",
    img: "https://images.pexels.com/photos/4063307/pexels-photo-4063307.jpeg?auto=compress&w=900",
    blurb: "Camera-ready looks for every kind of night.",
  },
  {
    title: "Bridal Makeup",
    startingFrom: "₹4,000",
    img: "https://images.pexels.com/photos/28941551/pexels-photo-28941551.jpeg?auto=compress&w=900",
    blurb: "Signature bridal looks — engagement to reception.",
  },
];

export const CATEGORIES = [
  {
    id: "hair-men",
    title: "Men's Hair",
    items: [
      { name: "Men's Haircut", price: "₹150" },
      { name: "Beard Styling", price: "₹100" },
      { name: "Shave", price: "₹70" },
      { name: "Hair Wash & Styling", price: "From ₹100" },
      { name: "Hair Spa", price: "From ₹500" },
      { name: "Hair Colour", price: "From ₹400" },
      { name: "Hair Polishing", price: "From ₹700" },
    ],
  },
  {
    id: "hair-women",
    title: "Women's Hair",
    items: [
      { name: "Haircut", price: "From ₹300" },
      { name: "Hair Spa", price: "From ₹600" },
      { name: "Hair Styling", price: "From ₹300" },
      { name: "Hair Ironing", price: "From ₹500" },
      { name: "Hair Curls", price: "From ₹500" },
      { name: "Hair Colour", price: "From ₹500" },
    ],
  },
  {
    id: "treatments",
    title: "Hair Treatments",
    items: [
      { name: "Rebonding", price: "From ₹2,500" },
      { name: "Keratin", price: "From ₹2,500" },
      { name: "Botox Treatment", price: "From ₹3,000" },
      { name: "Hair Smoothening", price: "From ₹3,500" },
      { name: "Nano Plastic", price: "From ₹4,000" },
      { name: "Kera Smooth", price: "From ₹4,500" },
      { name: "Oil Therapy", price: "From ₹5,000" },
    ],
  },
  {
    id: "facials",
    title: "Facials",
    items: [
      { name: "Face Scrub", price: "From ₹200" },
      { name: "Clean Up", price: "From ₹300" },
      { name: "Fruit Facial", price: "From ₹500" },
      { name: "Papaya Facial", price: "From ₹700" },
      { name: "Gold Facial", price: "From ₹1,000" },
      { name: "Aroma Magic Facial", price: "From ₹1,000" },
      { name: "Lotus Facial", price: "From ₹1,000" },
      { name: "D-Tan Facial", price: "From ₹1,000" },
      { name: "Anti Age Facial", price: "From ₹2,000" },
      { name: "O3 Facial", price: "From ₹2,000" },
      { name: "Korean Glass Facial", price: "From ₹5,000" },
    ],
  },
  {
    id: "hydra",
    title: "Hydra Facial",
    items: [
      { name: "Basic Hydra Facial", price: "₹2,000" },
      { name: "Advanced Hydra Facial", price: "₹3,500" },
    ],
  },
  {
    id: "dtan",
    title: "D-Tan",
    items: [
      { name: "Face D-Tan", price: "From ₹300" },
      { name: "Oxy D-Tan", price: "From ₹400" },
      { name: "Ozone D-Tan", price: "From ₹500" },
      { name: "Full Arm D-Tan", price: "From ₹600" },
      { name: "Full Body D-Tan", price: "From ₹2,500" },
    ],
  },
  {
    id: "mani-pedi",
    title: "Manicure & Pedicure",
    items: [
      { name: "Basic Manicure", price: "From ₹400" },
      { name: "Basic Pedicure", price: "From ₹500" },
      { name: "Classic Manicure", price: "From ₹600" },
      { name: "Classic Pedicure", price: "From ₹1,000" },
      { name: "Premium Mani-Pedi Combo", price: "From ₹2,000" },
    ],
  },
  {
    id: "waxing",
    title: "Waxing (Rica options available)",
    items: [
      { name: "Underarms Wax", price: "From ₹50" },
      { name: "Half Arms", price: "From ₹200" },
      { name: "Full Arms", price: "From ₹250" },
      { name: "Half Legs", price: "From ₹500" },
      { name: "Full Legs", price: "From ₹800" },
      { name: "Full Body Wax", price: "From ₹1,500" },
    ],
  },
  {
    id: "bleach",
    title: "Bleach",
    items: [
      { name: "Fruit Bleach", price: "From ₹200" },
      { name: "Gold Bleach", price: "From ₹250" },
      { name: "Oxy Bleach", price: "From ₹300" },
      { name: "Diamond Bleach", price: "From ₹400" },
      { name: "O3+ Bleach", price: "From ₹500" },
      { name: "Full Body Bleach", price: "From ₹2,000" },
    ],
  },
  {
    id: "party",
    title: "Party Makeup",
    items: [
      { name: "Party Makeup", price: "From ₹800" },
      { name: "Forever Makeup", price: "From ₹1,000" },
      { name: "MAC Makeup", price: "From ₹1,500" },
      { name: "HD Makeup", price: "From ₹2,000" },
      { name: "NARS Makeup", price: "From ₹2,500" },
    ],
  },
  {
    id: "bridal-makeup",
    title: "Bridal Makeup",
    items: [
      { name: "Engagement Makeup", price: "From ₹3,000" },
      { name: "Reception Makeup", price: "From ₹3,500" },
      { name: "Bridal Makeup", price: "From ₹4,000" },
      { name: "Bridal MAC Makeup", price: "From ₹5,000" },
      { name: "Bridal Studio Makeup", price: "From ₹7,000" },
      { name: "Bridal NARS Makeup", price: "From ₹10,000" },
    ],
  },
];

export const BRIDAL_PACKAGES = [
  {
    name: "Economy",
    price: "₹12,000",
    items: [
      "Cleaning",
      "Facial",
      "Threading",
      "Hair Spa",
      "Manicure",
      "Pedicure",
      "Bridal Makeup",
      "Hair Styling",
      "Dress Up",
    ],
  },
  {
    name: "Luxury",
    price: "₹15,000",
    items: [
      "Premium Facial",
      "D-Tan",
      "Full Body Polish",
      "Full Body Wax",
      "Hair Spa",
      "Haircut",
      "Manicure",
      "Pedicure",
      "Studio Bridal Makeup",
      "Hair Styling",
      "Dress Up",
    ],
  },
  {
    name: "Signature Luxury",
    price: "₹20,000",
    items: [
      "O3+ Facial",
      "Hydra Facial",
      "D-Tan",
      "Full Body Bleach",
      "Full Body Polish",
      "Hair Chemical Service",
      "Hair Spa",
      "Manicure",
      "Pedicure",
      "Premium Bridal NARS Makeup",
      "Hair Styling",
      "Dress Up",
    ],
  },
];

export const GROOM_PACKAGE = {
  name: "Groom Package",
  sittings: [
    {
      label: "Sitting 1",
      items: ["Haircut & Trimming", "Groom Facial", "Hair Spa"],
    },
    {
      label: "Sitting 2",
      items: [
        "Hair Colour",
        "D-Tan",
        "Manicure",
        "Pedicure",
        "Advanced Groom Facial",
      ],
    },
  ],
};

export const FAQS = [
  {
    q: "Do I need to book an appointment in advance?",
    a: "Walk-ins are welcome, but weekends and evenings fill quickly. Booking in advance guarantees your preferred stylist and time slot.",
  },
  {
    q: "Are your services suitable for both men and women?",
    a: "Yes — Good Looks is a unisex salon. Every service, from grooming to bridal, is available for both men and women.",
  },
  {
    q: "Which products do you use?",
    a: "We work with professional, salon-grade product ranges chosen for their safety and performance. Feel free to ask your stylist about specific brands used during your service.",
  },
  {
    q: "How long does a bridal appointment take?",
    a: "Bridal appointments vary by package. Please share your event date and requirements while booking so we can plan the sittings comfortably.",
  },
  {
    q: "Do you offer trials before the wedding day?",
    a: "Yes, bridal makeup and hair trials can be arranged. It's the best way to finalise your look with confidence.",
  },
  {
    q: "What is your cancellation policy?",
    a: "We ask for a courtesy 24-hour notice for cancellations or reschedules so we can offer the slot to someone else. Bridal bookings may have separate terms.",
  },
];

export const CHAPTERS = [
  {
    n: "01",
    title: "A neighbourhood atelier",
    body: "Good Looks is a modern, unisex salon rooted in Sunni Gali, Sadar — a calm, considered space designed for everyday grooming and once-in-a-lifetime moments alike.",
    img: "https://images.pexels.com/photos/27165069/pexels-photo-27165069.jpeg?auto=compress&w=900",
  },
  {
    n: "02",
    title: "Craft over trends",
    body: "Our approach is quiet and precise. Cuts are drawn to your face, colour is mixed for your tone, treatments are chosen for your hair — not the algorithm.",
    img: "https://images.pexels.com/photos/7195803/pexels-photo-7195803.jpeg?auto=compress&w=900",
  },
  {
    n: "03",
    title: "Made for the aisle",
    body: "From engagement to reception, our bridal chapters are planned across sittings so you arrive rested, radiant and unmistakably yourself.",
    img: "https://images.pexels.com/photos/34611749/pexels-photo-34611749.jpeg?auto=compress&w=900",
  },
];

export const REVIEW_PROMPTS = [
  "Your review helps neighbours find us.",
  "Tell us about your last visit — cut, colour, bridal or brow.",
  "Real words from real regulars mean the most.",
];
